module.exports = __webpack_public_path__ + "img/oil_paint_5.5b7c1ebc.png";